import { configureStore } from "@reduxjs/toolkit";
import moviesReducer from "./reducers/movies";
import userReducer from "./reducers/user.js";

export const store = configureStore({
    reducer: { 
        movies: moviesReducer,
        user: userReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;